import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoBranch24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M6.5 20.75C4.98122 20.75 3.75 19.5188 3.75 18C3.75 16.8344 4.47619 15.8407 5.5 15.4404V14C5.5 12.3431 6.84311 11 8.5 11L15.5 11C16.0523 11 16.5 10.5523 16.5 10V8.56055C15.476 8.16034 14.75 7.16574 14.75 6C14.75 4.48122 15.9812 3.25 17.5 3.25C19.0188 3.25 20.25 4.48122 20.25 6C20.25 7.16574 19.524 8.16034 18.5 8.56055V10C18.5 10.4261 18.4102 10.8311 18.25 11.1982V15.3574C19.4037 15.6842 20.25 16.7416 20.25 18C20.25 19.5188 19.0188 20.75 17.5 20.75C15.9812 20.75 14.75 19.5188 14.75 18C14.75 16.7416 15.5963 15.6842 16.75 15.3574V12.7256C16.3692 12.9005 15.9465 13 15.5 13L8.5 13C7.94769 13 7.5 13.4477 7.5 14V15.4404C8.52381 15.8407 9.25 16.8344 9.25 18C9.25 19.5188 8.01878 20.75 6.5 20.75ZM16.9912 7.14062C17.1404 7.05209 17.3139 7 17.5 7C17.6864 7 17.8604 7.05182 18.0098 7.14062C18.4458 6.94545 18.75 6.50864 18.75 6C18.75 5.30964 18.1904 4.75 17.5 4.75C16.8096 4.75 16.25 5.30964 16.25 6C16.25 6.50896 16.5547 6.94563 16.9912 7.14062ZM17.5 19.25C18.1904 19.25 18.75 18.6904 18.75 18C18.75 17.3096 18.1904 16.75 17.5 16.75C16.8096 16.75 16.25 17.3096 16.25 18C16.25 18.6904 16.8096 19.25 17.5 19.25ZM6.5 19.25C7.19036 19.25 7.75 18.6904 7.75 18C7.75 17.4915 7.44561 17.0556 7.00977 16.8604C6.86048 16.949 6.68622 17 6.5 17C6.31409 17 6.14034 16.9487 5.99121 16.8604C5.55492 17.0554 5.25 17.4912 5.25 18C5.25 18.6904 5.80964 19.25 6.5 19.25Z" fill={iconColor} />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoBranch24;